import { Checkbox, TableCell, TableRow } from "@mui/material";
import typography from "constants/typography.constants";
import { DataWithIstelegramFlag } from "../types";

interface RowProps {
  row: DataWithIstelegramFlag;
  isItemSelected: boolean;
  labelId: `enhanced-table-checkbox-${number}`;
  handleClick: (id: string) => void;
}

const Row = ({ row, isItemSelected, labelId, handleClick }: RowProps) => {
  return (
    <TableRow
      hover
      onClick={() => handleClick(row.id)}
      role='checkbox'
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{ cursor: "pointer" }}>
      <TableCell align='center'>
        <Checkbox
          color='primary'
          size='small'
          checked={isItemSelected}
        />
      </TableCell>
      <TableCell
        id={labelId}
        scope='row'>
        {row.numericId}
      </TableCell>
      <TableCell>{row.fullName}</TableCell>
      {row.isTelegramUser ? (
        <TableCell title={typography.candidate.form.withTelegram}>@{row.nickname}</TableCell>
      ) : (
        <TableCell title={typography.candidate.form.withLogin}>{row.nickname || ""}</TableCell>
      )}
      <TableCell>{row.createdAt}</TableCell>
    </TableRow>
  );
};

export default Row;
